import { useCallback, useContext, useEffect, useState } from "react";
import { SocketContext } from "../../contexts/SocketContext";
import { AlertContext } from "../../contexts/AlertContext";
import { LoaderContext } from "../../contexts/LoaderContext";
import { useParams } from 'react-router-dom';

export const useAsset = () => {

    const [asset, setAsset] = useState({});
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { id } = useParams();

    useEffect(() => {
        let subscribed = true;
        subscribed && getAsset();

        return () => subscribed = false;
    }, []);

    const getAsset = useCallback(() => {
        setOpenLoader(true);
        socket.emit('frontend:obtener-activo', { id }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }

            setAsset(data);
            setOpenLoader(false);
        });
    }, []);
	
    return {
        asset
    }
}